import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UserConsentsDialogData} from '../../models/user-consents/user-consents-dialog-data';
import {UserConsentsService} from '../services/user-consents.service';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AuthService} from '../services/user-services/auth.service';
import {LegalDocumentsService} from '../services/legal-documents.service';

@Component({
  selector: 'app-user-consents-dialog',
  templateUrl: './user-consents-dialog.component.html',
  styleUrls: ['./user-consents-dialog.component.scss']
})
export class UserConsentsDialogComponent implements OnInit {

  form: FormGroup;
  controls = [
    {
      name: 'privacy',
      formState: false,
      validators: [Validators.requiredTrue],
      toAdd: this.data.needsPrivacy
    },
    {
      name: 'terms',
      formState: false,
      validators: [Validators.requiredTrue],
      toAdd: this.data.needsTerms
    }
  ];
  loading = false;

  constructor(
    private dialogRef: MatDialogRef<UserConsentsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: UserConsentsDialogData,
    private fb: FormBuilder,
    private userConsentsService: UserConsentsService,
    private authService: AuthService,
    private legalDocumentsService: LegalDocumentsService,
  ) {
    this.form = this.fb.group({});
  }

  ngOnInit(): void {
    this.controls
      .filter(control => control.toAdd)
      .forEach(control =>
        this.form.addControl(
          control.name,
          new FormControl(control.formState, control.validators)
        )
      );
  }

  confirm() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.loading = true;

    this.userConsentsService.addConsent(this.form.value)
      .subscribe(
        () => {
          this.loading = false;
          this.dialogRef.close(true);
        },
        () => {
          this.loading = false;
          this.dialogRef.close(true);
        }
      );
  }

  async logout() {
    await this.authService.logout();
  }

  download(type: number, event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.legalDocumentsService.downloadActiveLegalDocument(type);
  }
}
